


















import { Component, Vue } from "vue-property-decorator";
import { Citr } from "@/sergecych.uni3/Citr";
import { defaultCitr } from "@/lib/globals";

console.log("123");

@Component
export default class Reset extends Vue {
  reset() {
    console.log("reset!");
    localStorage.removeItem("login");
    localStorage.removeItem("password");
    localStorage.removeItem("lastQRCode");
    window.location.replace("/");
  }
  createReport() {
    defaultCitr().createCrypstie();
  }
}
